import angular from "angular";
import uiRouter from "angular-ui-router";
import "jsoneditor/dist/jsoneditor.css";
import JSONEditor from "jsoneditor/dist/jsoneditor.min";
import "ng-jsoneditor/ng-jsoneditor.js";
import "angular-tooltips";
import "lf-ng-md-file-input";
import "lf-ng-md-file-input/dist/lf-ng-md-file-input.css";
import "angular-tooltips/dist/angular-tooltips.css";
import "angular-toastr/dist/angular-toastr.css";
import "angular-toastr";
// import "font-awesome/css/font-awesome.css";
import "normalize.css";
// import "bootstrap-webpack";
import 'bootstrap/dist/css/bootstrap.css';
import "./components/ngProgress/ngProgress";
import "./components/ngProgress/ngProgress.css";
import "./components/angularBreadcrumb/angularBreadcrumb";
import "./components/angular-material-datetimepicker/js/angular-material-datetimepicker";
import "./components/angular-material-datetimepicker/css/material-datetimepicker.css";
import "./components/angular-directive.g-signin/google-signin";
import "restangular";
import "angular-material";
import "sweetalert";
import "angular-h-sweetalert";
import "sweetalert/dist/sweetalert.css";
import "angular-cookies";
import "angular-sanitize";
import "angular-ui-bootstrap";
import "ngclipboard";
// import "jquery";
import "email-validator";
import "./components/angularBreadcrumb/angularBreadcrumb";
import "angular-debounce";
import "angular/angular.js";
import "angular-material/angular-material.css";
import "./scss/vendor.scss";
import "./scss/index.scss";
import _ from "lodash";
import "./components/angular-bootstrap-toggle-master/built/angular-bootstrap-toggle.css";
import "./components/angular-bootstrap-toggle-master/built/angular-bootstrap-toggle";
import "angular-validation/dist/angular-validation-rule";
import "angular-validation/dist/angular-validation";
import $ from 'jquery';
window.$ = $;
window.jQuery = $;
window._ = _;
window.angular = angular;
window.JSONEditor = JSONEditor


export let app = angular.module('skykitProvisioning', [
  uiRouter,
  'ngAnimate',
  '720kb.tooltips',
  'ngCookies',
  'ngSanitize',
  'restangular',
  'ui.toggle',
  'ui.bootstrap',
  'ngMaterialDatePicker',
  'hSweetAlert',
  'ncy-angular-breadcrumb',
  'directive.g-signin',
  'ngProgress',
  'rt.debounce',
  'ngMaterial',
  'ngclipboard',
  'toastr',
  'lfNgMdFileInput',
  'ng.jsoneditor',
  'validation',
  'validation.rule'
])
// .config(function($mdThemingProvider) {

//   $mdThemingProvider.definePalette('amazingLightPaletteName', {
//     '50': '#f1f8e9',
//     '100': '#dcedc8',
//     '200': '#c5e1a5',
//     '300': '#aed581',
//     '400': '#9ccc65',
//     '500': '#8bc34a',
//     '600': '#7cb342',
//     '700': '#689f38',
//     '800': '#558b2f',
//     '900': '#33691e',
//     'A100': '#ccff90',
//     'A200': '#b2ff59',
//     'A400': '#76ff03',
//     'A700': '#64dd17',
//     // By default, text (contrast) on this palette should be dark with 87% opacity.
//     'contrastDefaultColor': 'dark',
//     // By default, for these darker hues, text (contrast) should be white with 100% opacity.
//     'contrastStrongLightColors': '800 900'
//   });

//   $mdThemingProvider.theme('default')
//     .accentPalette('amazingLightPaletteName')
// });